import Vue from 'vue'
import {
  usersClient
} from '@api/users'

const initialState = () => ({
  users: [],
  roles: [],
  pagination: {
    pageNum: 1,
    pageSize: 10,
    totalCount: 0,
    rowsPerPageItems: [10, 20, 30, 40, 50, 100]
  },
  promises: {
    rolesFetchPromise: undefined,
    usersFetchPromise: undefined,
    usersSavePromise: undefined,
    usersDeletePromise: undefined
  }
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    list: state => state.users,
    roles: state => state.roles,
    usersFetching: state => state.promises.usersFetchPromise !== undefined,
    userDeleting: state => state.promises.usersDeletePromise !== undefined,
    usersSaving: state => state.promises.usersSavePromise !== undefined,
    pagination: state => state.pagination
  },
  mutations: {
    reset (state) {
      const initial = initialState()
      Object.keys(initial).forEach(k => {
        state[k] = initial[k]
      })
    },
    setUsers (state, {
      users,
      totalCount
    }) {
      state.users = users
      Vue.set(state.pagination, 'totalCount', totalCount)
    },
    setRoles (state, {
      roles
    }) {
      state.roles = roles
    },
    setPagination (state, payload) {
      state.pagination = payload
    },

    deleteUserById (state, userId) {
      const index = state.users.findIndex(x => x.id === userId)
      if (index >= 0) {
        state.users.splice(index, 1)
      } else throw Error(`Wrong user id: ${userId}`)
    },
    usersFetchPromise (state, promise) {
      state.promises.usersFetchPromise = promise
    },
    usersSavePromise (state, promise) {
      state.promises.usersSavePromise = promise
    },
    usersDeletePromise (state, promise) {
      state.promises.usersDeletePromise = promise
    },
    rolesFetchPromise (state, promise) {
      state.promises.rolesFetchPromise = promise
    }

  },
  actions: {
    fetchRoles (ctx) {
      if (ctx.getters.usersFetchPromise) return
      const promise = usersClient.getRoles()
        .then(resp => {
          const {
            roles
          } = resp.data
          ctx.commit('rolesFetchPromise', undefined)
          ctx.commit('setRoles', {
            roles
          })
          return resp
        })
        .catch(error => {
          ctx.commit('rolesFetchPromise', undefined)
          throw error
        })
      ctx.commit('rolesFetchPromise', promise)
      return promise
    },
    getUser (ctx, id) {
      if (ctx.getters.usersFetching) return
      const promise = usersClient.getUser(id)
        .then(resp => {
          ctx.commit('usersFetchPromise', undefined)
          return resp
        })
        .catch(error => {
          ctx.commit('usersFetchPromise', undefined)
          throw error
        })
      ctx.commit('usersFetchPromise', promise)
      return promise
    },
    addUser (ctx, user) {
      if (ctx.getters.usersSaving) return
      const promise = usersClient.postUser(user)
        .then(resp => {
          ctx.commit('usersSavePromise', undefined)
          return resp
        })
        .catch(error => {
          ctx.commit('usersSavePromise', undefined)
          throw error
        })
      ctx.commit('usersSavePromise', promise)
      return promise
    },
    saveUser (ctx, {
      id,
      user
    }) {
      if (ctx.getters.usersSaving) return
      const promise = usersClient.putUser(id, user)
        .then(resp => {
          ctx.commit('usersSavePromise', undefined)
          return resp
        })
        .catch(error => {
          ctx.commit('usersSavePromise', undefined)
          throw error
        })
      ctx.commit('usersSavePromise', promise)
      return promise
    },
    fetchUsers (ctx) {
      if (ctx.getters.usersFetching) return
      const {
        pageNum,
        pageSize
      } = ctx.state.pagination
      const promise = usersClient.getUsers(pageNum, pageSize)
        .then(resp => {
          const {
            users,
            totalCount
          } = resp.data
          ctx.commit('usersFetchPromise', undefined)
          ctx.commit('setUsers', {
            users,
            totalCount
          })
          return resp
        })
        .catch(error => {
          ctx.commit('usersFetchPromise', undefined)
          throw error
        })
      ctx.commit('usersFetchPromise', promise)
      return promise
    },
    deleteUser (ctx, {
      id
    }) {
      if (ctx.getters.userDeleting) return
      const promise = usersClient.deleteUser(id)
        .then(resp => {
          ctx.commit('usersDeletePromise', undefined)
          ctx.commit('deleteUserById', id)
          return resp
        })
        .catch(error => {
          ctx.commit('usersDeletePromise', undefined)
          throw error
        })
      ctx.commit('usersDeletePromise', promise)
      return promise
    }

  }
}



// WEBPACK FOOTER //
// ./src/state/users-module.js